import { Typography, Dialog, DialogContent } from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import NavPills from "components/NavPills/NavPills.js";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import style from "./ProgramSectionStyle";
import ContainerFullHeight from "components/ContainerFullHeight/ContainerFullHeight";
import preciosEs from "assets/img/25/Precios Español.png";
import preciosEn from "assets/img/25/Precios Inglés.png";

const useStyles = makeStyles(style);

export default function ProgramSection({ id, t }) {
  const classes = useStyles();
  const { i18n } = useTranslation();

  const pricingImageSrc = i18n.language === "es" ? preciosEs : preciosEn;
  const [openImage, setOpenImage] = useState(false);

  const hotelVideoLink = "https://www.youtube.com/watch?v=pvz5gaVzKOI";
  return (
    <ContainerFullHeight id={id} bgColor="white" paddingBottom="none">
      <div className={classes.container}>
        <GridContainer className={classes.mainGridContainer}>
          <GridItem xs={12} sm={12} md={12}>
            <h3 className={classes.title}>{t("programSectionTitle")}</h3>
            <NavPills
              color="info"
              tabs={[
                {
                  tabButton: t("programDates"),
                  tabButtonProps: { className: classes.customTabButton },
                  tabContent: (
                    <Typography className={classes.tabContent} variant="body1">
                      {t("programDatesText")}
                      <br />
                      <a href={hotelVideoLink} target="_blank">
                        <u>{t("programDatesLink")}</u>
                      </a>
                    </Typography>
                  ),
                },
                {
                  tabButton: t("programOptions"),
                  tabButtonProps: { className: classes.customTabButton },
                  tabContent: (
                    <>
                      <Typography
                        className={classes.tabContent}
                        variant="body1"
                      >
                        {t("programOptionsSubtitle")}
                      </Typography>
                      <ul className={classes.tabContentText}>
                        <li>
                          <b>{t("programOptionsText1Title")}</b>
                          {t("programOptionsText1")}
                        </li>
                        <li>
                          <b>{t("programOptionsText2Title")}</b>
                          {t("programOptionsText2")}
                        </li>
                        <li>
                          <b>{t("programOptionsText3Title")}</b>
                          {t("programOptionsText3")}
                        </li>
                      </ul>
                    </>
                  ),
                },
                {
                  tabButton: <>{t("programPricings")}</>,
                  tabButtonProps: { className: classes.customTabButton },
                  tabContent: (
                    <>
                      <img
                        src={pricingImageSrc}
                        alt={t("programPricingsText")}
                        style={{
                          width: "50%",
                          height: "auto",
                          marginTop: "1rem",
                          display: "block",
                          marginLeft: "auto",
                          marginRight: "auto",
                          cursor: "zoom-in"
                        }}
                        onClick={() => setOpenImage(true)}
                      />
                      <Dialog
                        open={openImage}
                        onClose={() => setOpenImage(false)}
                        maxWidth="md"
                      >
                        <DialogContent style={{ padding: 0 }}>
                          <img
                            src={pricingImageSrc}
                            alt="Program Pricing Enlarged"
                            style={{ width: "100%", height: "auto" }}
                          />
                        </DialogContent>
                      </Dialog>
                    </>
                  ),
                },
              ]}
            />
          </GridItem>
        </GridContainer>
      </div>
    </ContainerFullHeight>
  );
}
